import React, { useState } from "react";
// Shared layouts
import PanelAvailabilityCopy from "./components/Graph";
import PanelAvailabilityMaintenance from "./components/GeneralStatusMaintenance/Graph";
import { withRouter } from "react-router-dom";
import { generateDefaultFilters } from "../../utils/generate-default-filters-by-url-query-params";

function GeneralStatusZoom({ location }) {
    let admin = sessionStorage.getItem('admin')
    const [defaultFilterParams] = useState(
        generateDefaultFilters(document.location.search)
    );
    /*if (admin) 
        return <PanelAvailabilityMaintenance {...defaultFilterParams} />;
    else 
        return <PanelAvailabilityCopy {...defaultFilterParams} />;*/
    return <PanelAvailabilityCopy {...defaultFilterParams} />
}

export default withRouter(GeneralStatusZoom);
